import React, { useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import Actions from "actions";
import Cookies from "cookies-js";
import Loading from "components/blocks/Loading.component.web";
import { addUnregisteredUser, getUser } from "api/users";

async function initializeUser() {
  console.log('initializeUser - Starting external auth process');
  try {
    let userData = Cookies.get("userData");
    let userId;
    let token;

    console.log('initializeUser - Cookie data:', { 
      hasCookie: !!userData, 
      cookieValue: userData ? userData.split(':')[0] + ':***' : 'none'
    });

    if (userData) {
      userData = userData.split(":");
      userId = userData[0];
      token = userData[1];
    }
    if (typeof userId !== "undefined" && typeof token !== "undefined") {
      console.log('initializeUser - Making getUser API call for userId:', userId);
      return getUser(token, userId)
        .then((json) => {
          console.log('initializeUser - getUser API success:', {
            userId: json._id,
            status: json.status,
            toolIds: json.tool_ids,
            hasToolIds: !!json.tool_ids?.length,
            timestamp: new Date().toISOString()
          });
          Cookies.set("userData", json._id + ":" + json.token);
          return json;
        })
        .catch((error) => {
          console.error('initializeUser - getUser API failed:', error);
          userId = undefined;
          token = undefined;
          return addUnregisteredUser();
        });
    } else {
      console.log('initializeUser - No valid cookie, creating unregistered user');
      return addUnregisteredUser().then((json) => {
        Cookies.set("userData", json._id + ":" + json.token);
        return json;
      });
    }
  } catch (e) {
    console.error('initializeUser - Exception:', e);
  }
}

export const AuthProvider = ({ children }) => {
  const store = useStore();
  const dispatch = useDispatch();

  const hydrated = useSelector((state) => state._persist?.rehydrated ?? false);
  const user = useSelector((state) =>
    !!state.auth.user?._id ? state.auth.user : null
  );

  console.log('AuthProvider - Render cycle:', {
    hydrated,
    hasUser: !!user,
    userSource: user ? 'redux_state' : 'none',
    timestamp: new Date().toISOString()
  });

  useEffect(() => {
    console.log('AuthProvider - Hydration effect:', { hydrated, user: !!user });
    if (hydrated && !user) {
      console.log('AuthProvider - No user after hydration, initializing from external source');
      initializeUser().then((initializedUser) => {
        console.log('AuthProvider - External user initialized:', {
          userId: initializedUser?._id,
          status: initializedUser?.status,
          toolIds: initializedUser?.tool_ids,
          source: 'external_app'
        });
        store.dispatch(Actions.setUser(initializedUser));
      });
    }
  }, [hydrated]);

  useEffect(() => {
    if(!!user){
      store.dispatch(Actions.setUser(user));
    }
  }, [user])

  useEffect(() => {
    if (!!user?._id) {
      const { _id: userId, token: userToken, status } = user;

      console.log('AuthProvider - Loading tools for user:', {
        userId,
        status,
        isNewUser: status === 'normal' && !user?.dt_c,
        toolIds: user?.tool_ids,
        timestamp: new Date().toISOString()
      });

      if (status === "unregistered") {
        dispatch(
          Actions.getTool(userToken, CUAC_SETTINGS.GROUP.screener_tool_id)
        );
      } else {
        console.log('AuthProvider - Dispatching getSimplifiedTools for status:', status);
        dispatch(Actions.getSimplifiedTools(userToken));
        dispatch(Actions.getTrackerEntries(userToken, userId));
        dispatch(Actions.getTrackerEntryStats(userToken, userId));
        dispatch(Actions.getAllReminders(userId, userToken));
      }

      dispatch(Actions.getSubscriptions(userToken));
      dispatch(Actions.getPlans(userToken, CUAC_SETTINGS.GROUP._id))
      dispatch(Actions.getNorms(userToken))
      dispatch(Actions.getResponses(userToken, userId));
      
    }
  }, [user]);

  useEffect(() => {
    dispatch(Actions.getTerms(_.get(CUAC_SETTINGS, "GROUP.terms_id")));
  }, []);

  if (!hydrated || !user) {
    return (
      <Loading
        loading
        text={<h4 className="mb-0 ms-2 fw-bold">Loading...</h4>}
      />
    );
  }

  return children;
};
